import { PERSON_STATUS_AUTHORIZATION } from '@/services/models.const'

export default {
  namespaced: true,
  state: {
    customer: {},
    controls: {},
    customerFile: {},
    fields: {},
    formErrors: {},
    formAlerts: [],
    personControlId: '',
  },
  mutations: {
    setCurrentCustomer: (state, customer) => {
      state.customer = customer
    },
    setCurrentCustomerFile: (state, customerFile) => {
      state.customerFile = customerFile
    },
    setCurrentControls: (state, controls) => {
      state.controls = controls
    },
    setCustomerFields: (state, fields) => {
      state.fields = fields
    },
    setPersonControlId: (state, personControlId) => {
      state.personControlId = personControlId
    },
    setFormErrors(state, errors) {
      state.formErrors = errors
    },
    resetFormErrors(state) {
      state.formErrors = {}
    },
    setFormAlerts(state, alerts) {
      state.formAlerts = alerts
    },
    resetFormAlerts(state) {
      state.formAlerts = []
    },
  },
  getters: {
    currentCustomer: (state) => {
      return state.customer
    },
    currentCustomerFile: (state) => {
      return state.customerFile
    },
    customerFileStatus: (state) => {
      if (!state.customer || !state.customer.meta) {
        return ''
      }

      return state.customer.meta.customer_file_status
    },
    authorization: (state) => {
      if (!state.customer || !state.customer.meta) {
        return ''
      }
      const customerFileStatus = state.customer.meta.customer_file_status
      const authorization = PERSON_STATUS_AUTHORIZATION[customerFileStatus]

      return authorization
    },
    currentControls: (state) => {
      return state.controls
    },
    currentFields: (state) => {
      return state.fields
    },
    personControlId: (state) => {
      return state.personControlId
    },
    formErrors: (state) => {
      return state.formErrors
    },
    formAlerts: (state) => {
      return state.formAlerts
    },
  },
}
